import { useEffect } from "react";
import "./rangePickerCloseButton.css";

const PANEL_SELECTOR = ".custom-range-picker";
const CALENDAR_SELECTOR = ".custom-range-picker .ant-calendar";
const BTN_CLASS = "range-picker-close-btn";

function createCloseButton(onClose) {
  const closeBtn = document.createElement("button");
  closeBtn.type = "button";
  closeBtn.className = BTN_CLASS;
  closeBtn.setAttribute("aria-label", "Close date picker");
  closeBtn.innerHTML = "&times;";
  closeBtn.onclick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof onClose === "function") onClose();
  };
  return closeBtn;
}

/**
 * Injects a close (X) button into the white ant-calendar panel
 * (not the wide picker-container, which caused extreme-right positioning).
 * Returns a cleanup function.
 */
export function attachRangePickerCloseButton(onClose) {
  let cancelled = false;

  const inject = () => {
    if (cancelled) return;
    document.querySelectorAll(CALENDAR_SELECTOR).forEach((calendar) => {
      if (calendar.querySelector(`.${BTN_CLASS}`)) return;
      calendar.appendChild(createCloseButton(onClose));
    });
  };

  // Calendar may mount a tick after open flips true
  const timer = setTimeout(inject, 0);
  const timer2 = setTimeout(inject, 50);

  return () => {
    cancelled = true;
    clearTimeout(timer);
    clearTimeout(timer2);
    document
      .querySelectorAll(`${PANEL_SELECTOR} .${BTN_CLASS}`)
      .forEach((el) => el.remove());
  };
}

/** Hook for functional components with controlled RangePicker `open` state. */
export function useRangePickerCloseButton(open, setOpen) {
  useEffect(() => {
    if (!open) return undefined;
    return attachRangePickerCloseButton(() => setOpen(false));
  }, [open, setOpen]);
}



// WEBPACK FOOTER //
// ./src/utils/rangePickerCloseButton.js